<div [ngClass]="{ minimized: isMinimized(), 'disable-animation': disableAnimation() }" class="wrapper">
  <div class="header">
    <app-title-nav-bar />
  </div>
  <nav [ngClass]="{ minimized: isMinimized() }" class="nav">
    <ul class="nav-bar-list">
      @for (listItem of menuItems(); track i; let i = $index) {
        @if (isVisible(listItem.visible)) {
          @if (listItem.children) {
            <app-item-button-nav-bar [listItem]="listItem" />
          } @else {
            <app-item-link-nav-bar [listItem]="listItem" />
          }
        }
      }
    </ul>
  </nav>
</div>
